import { render, staticRenderFns } from "./MonatlFreigabe.vue?vue&type=template&id=f736da54&scoped=true"
import script from "./MonatlFreigabe.vue?vue&type=script&lang=ts"
export * from "./MonatlFreigabe.vue?vue&type=script&lang=ts"
import style0 from "./MonatlFreigabe.vue?vue&type=style&index=0&id=f736da54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f736da54",
  null
  
)

export default component.exports